import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import logo from './logo_app.png';
import './App.css';
import Terms from './components/Terms';
import AppBar from './components/AppBar';
import DeleteAccount from './components/DeleteAccount';
import AccountConfirmed from './components/AccountConfirmed';
import TermsPrompteX from './components/TermsPrompteX';

function HeroSection({ id, badge, title, description, image, reversed, storeLinks }) {
  return (
    <section id={id} className={`hero ${reversed ? 'reversed' : ''}`}>
      <div className="hero-content">
        {badge && <span className="section-badge">{badge}</span>}
        <h1>{title}</h1>
        <p>{description}</p>

        <div className="stores-container">
          <a href={storeLinks?.ios || "#"} className="store-button">
            <span>Disponível na</span>
            <strong>App Store</strong>
          </a>
          <a href={storeLinks?.android || "#"} className="store-button">
            <span>Disponível na</span>
            <strong>Google Play</strong>
          </a>
        </div>
      </div>

      <div className="hero-visual">
        <div className="phone-mockup">
          <div className="phone-notch"></div>
          <div className="phone-screen" style={{ background: reversed ? '#f0fdfa' : '#fff' }}>
            <img src={image} alt={`${badge} App`} className="phone-logo" />
            {reversed && <div style={{marginTop: '10px', fontWeight: 'bold', color: '#0d9488'}}>Vendedor</div>}
          </div>
        </div>
      </div>
    </section>
  );
}

function Home() {
  return (
    <>
      <HeroSection 
        badge="SeandMe Comprador"
        title="Sua praia ainda mais especial"
        description="Conecte-se com vendedores locais, descubra serviços exclusivos e faça seu dia na praia melhor com SeandMe."
        image={logo}
        storeLinks={{ ios: "https://apps.apple.com/br/app/seandme/id6760015510", android: "https://play.google.com/store/apps/details?id=com.saendme.comprador" }}
      />
      
      <HeroSection 
        badge="SeandMe Vendedor"
        title="Venda mais e melhor na areia"
        description="Gerencie seus pedidos, aceite pagamentos digitais e alcance mais clientes com a plataforma feita para o trabalhador da praia."
        image={logo}
        reversed={true}
        storeLinks={{ ios: "https://apps.apple.com/br/app/seandme-vendedor/id6760121212", android: "https://play.google.com/store/apps/details?id=com.seandme.vendedor&hl=pt_BR" }}
      />

      <div className="legal-container" style={{ margin: '4rem auto', width: '100%', textAlign: 'center' }}>
        <Link to="/terms" className="legal-link">
          Termos de Uso e Políticas de Privacidade
        </Link>
      </div>
    </>
  );
}

function App() {
  return (
    <Router basename={"/"}>
      <Routes>
        <Route path="/terms-promptex" element={<TermsPrompteX />} />
        <Route
          path="*"
          element={
            <div className="App">
              <AppBar />
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="/delete-account" element={<DeleteAccount />} />
                <Route path="/account-confirmed" element={<AccountConfirmed />} />
              </Routes>
            </div>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
